import { createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { cancelFunding, resetCancelFunding } from "./cancel-funding";

const initialState: ProcessingState = { processing: "idle" };

export const cancelFundingReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(cancelFunding.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(cancelFunding.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(cancelFunding.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetCancelFunding, () => {
    return initialState;
  });
});
